export default __webpack_public_path__ + "svg/calendar/2026/8/octubre.svg?c0b24f26";